import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import { AlertTriangle } from 'lucide-react';

const ResolveDisputeDialog = ({
  disputeMatch,
  clubs,
  resolveForm,
  setResolveForm,
  resolveLoading,
  isItalian,
  onResolve,
  onClose,
}) => {
  const getClub = (clubId) => clubs.find((c) => c.club_id === clubId);

  return (
    <Dialog open={!!disputeMatch} onOpenChange={() => onClose()}>
      <DialogContent className="bg-[#0a0d15] border-[#FF1744]/20 text-white max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl uppercase tracking-wider flex items-center gap-2">
            <AlertTriangle size={20} className="text-[#FF1744]" />
            {isItalian ? 'Risolvi Contestazione' : 'Resolve Dispute'}
          </DialogTitle>
        </DialogHeader>
        {disputeMatch && (
          <div className="space-y-4 mt-4">
            {/* Show both reports */}
            <div className="grid grid-cols-2 gap-3">
              {(disputeMatch.reports || []).map((r, idx) => {
                const rClub = getClub(r.club_id);
                const isSelected = resolveForm.accepted_report_index === idx;
                return (
                  <button
                    key={idx}
                    className={`p-3 rounded border text-center transition-all ${
                      isSelected
                        ? 'bg-[#00F0FF]/10 border-[#00F0FF]/40'
                        : 'bg-[#050508] border-white/10 hover:border-white/30'
                    }`}
                    onClick={() => setResolveForm(prev => ({
                      ...prev,
                      home_score: r.home_score,
                      away_score: r.away_score,
                      accepted_report_index: idx,
                    }))}
                    data-testid={`select-report-${idx}`}
                  >
                    <p className="text-xs text-slate-500 mb-1">
                      {isItalian ? 'Report di' : 'Report by'} {rClub?.name || '?'}
                    </p>
                    <p className="font-mono text-2xl font-bold text-white">{r.home_score} - {r.away_score}</p>
                    <p className="text-[10px] text-slate-500 mt-1">
                      {r.events?.length || 0} {isItalian ? 'eventi' : 'events'}
                    </p>
                    {isSelected && (
                      <span className="inline-block mt-1 px-2 py-0.5 text-[9px] bg-[#00F0FF]/20 text-[#00F0FF] border border-[#00F0FF]/30 rounded uppercase tracking-wider font-bold">
                        {isItalian ? 'Selezionato' : 'Selected'}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>

            <div className="text-center text-xs text-slate-500 uppercase tracking-wider">
              {isItalian ? 'oppure inserisci risultato manuale' : 'or enter manual result'}
            </div>

            {/* Manual score */}
            <div className="grid grid-cols-3 gap-4 items-center">
              <div className="text-center">
                <p className="text-sm text-slate-500 mb-2">
                  {getClub(disputeMatch.home_club_id)?.name}
                </p>
                <Input
                  type="number"
                  min={0}
                  value={resolveForm.home_score}
                  onChange={(e) => setResolveForm(prev => ({
                    ...prev,
                    home_score: parseInt(e.target.value) || 0,
                    accepted_report_index: null,
                  }))}
                  className="bg-[#050508] border-white/10 text-white text-center font-mono text-2xl"
                  data-testid="resolve-home-score"
                />
              </div>
              <div className="text-center text-2xl font-bold text-slate-500">-</div>
              <div className="text-center">
                <p className="text-sm text-slate-500 mb-2">
                  {getClub(disputeMatch.away_club_id)?.name}
                </p>
                <Input
                  type="number"
                  min={0}
                  value={resolveForm.away_score}
                  onChange={(e) => setResolveForm(prev => ({
                    ...prev,
                    away_score: parseInt(e.target.value) || 0,
                    accepted_report_index: null,
                  }))}
                  className="bg-[#050508] border-white/10 text-white text-center font-mono text-2xl"
                  data-testid="resolve-away-score"
                />
              </div>
            </div>

            <Button
              className="w-full bg-[#FF1744] hover:bg-[#D50000] text-white font-bold uppercase tracking-wider"
              onClick={onResolve}
              disabled={resolveLoading}
              data-testid="confirm-resolve-dispute"
            >
              {resolveLoading ? (
                <span className="flex items-center gap-2 justify-center">
                  <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  {isItalian ? 'Conferma in corso...' : 'Confirming...'}
                </span>
              ) : (
                isItalian ? `Conferma Risultato ${resolveForm.home_score}-${resolveForm.away_score}` : `Confirm Result ${resolveForm.home_score}-${resolveForm.away_score}`
              )}
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ResolveDisputeDialog;
